// extracted by mini-css-extract-plugin
export default {"pagination-container":"lWNLWgcmL86KwH7hsn83","paginationContainer":"lWNLWgcmL86KwH7hsn83"};